import UserServiceClient from 'app/clients/userService'

export const fetchCandidatesAPI = (data, signal) => {
  // console.log('Signal in fetchCandidatesAPI:', signal)
  // console.log('Signal aborted:', signal.aborted)
  return UserServiceClient.post(`/get-candidates-open-search`, data, { signal }) // Pass signal inside a config object
}

export const fetchCandidateAPI = (id) => {
  return UserServiceClient.get(`/get-candidate-by-id/${id}`)
}